import log from "loglevel";
import { useState, createContext } from "react";

const PostContext = createContext({
  post: {
    id: 0,
    title: '',
    content: '',
    author_name: '',
    comments: [],
    modified_at: '',
    tags: [],
  },
  setPost: () => {},
});

const PostProvider = ({ children }) => {
  log.debug('CONTEXT_POST_PROVIDER');
  
  const [post, setPost] = useState({
    id: 0,
    title: '',
    content: '',
    author_name: '',
    comments: [],
    modified_at: '',
    tags: [],
  });

  const value = {
    post,
    setPost,
  };

  return (
    <PostContext.Provider value={value}>{children}</PostContext.Provider>
  );
};

export { PostProvider };

export default PostContext;
